import { useAppSelector } from '@frontend/common';
import { DestinationConstraintData, isDestinationConstraintData } from '@frontend/constraint/types';
import { formStore, updateField } from '@frontend/repository';
import { useEffect } from 'react';
import { useSelector } from 'react-redux';

import { DestinationConstraintDataInputProps } from './destination-constraint-data-input.component';

interface ViewProps {
    formValues: DestinationConstraintData;
}

const useDestinationConstraintDataInput = (props: DestinationConstraintDataInputProps): ViewProps => {
    const store = useAppSelector(useSelector, formStore);
    const formValues = store[props.formId]?.value['data'];

    useEffect(() => {
        if (!isDestinationConstraintData(store[props.formId]?.value['data'])) {
            props.dispatch(updateField({ formId: props.formId, key: 'data', value: { spot_id: null } }));
        }
    }, []);

    return {
        formValues
    };
};

export default useDestinationConstraintDataInput;
